import {observer} from 'mobx-react-lite'
import React from 'react'
import {useColumnStore} from '@components/columns/column-store'
import {Icon} from '@components/common/base/icon'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'

export const AggregatedStickerValues = observer(() => {
  const [state] = useColumnStore()

  return (
    <WithPerfectScrollbar className="max-h-100 h-auto w-full py-4">
      <div className="flex flex-col gap-8 text-12">
        {Array.from(state.numericStickersSum).map(
          ([stickerId, {title, value}]) => {
            return (
              <div
                key={stickerId}
                className="text-primary font-normal flex items-center"
              >
                <Icon icon="IconSum" className="mr-6" /> {title}:{' '}
                {Number(value).toLocaleString('ru-RU')}
              </div>
            )
          }
        )}
      </div>
    </WithPerfectScrollbar>
  )
})
